import { Component, Inject, OnInit } from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {LocalStorageSettingsService} from "../../../shared/services/local-storage-settings.service";
import {ErrorMessages} from "../../../shared/common/errormessages";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {MatSnackBar} from "@angular/material/snack-bar";
import {CommonService} from "../../../shared/services/common.service";
import {EtlService} from "../../vault-data-migration-etl/etl.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {validationmethod} from "../../../shared/common/validationmethod";



@Component({
    selector: 'app-add-sets-for-migration-popup',
    templateUrl: './add-sets-for-migration-popup.component.html',
    styleUrls: ['./add-sets-for-migration-popup.component.scss'],
    standalone: false
})
export class AddSetsForMigrationPopupComponent implements OnInit {
  objectGroupOptions: Number[] = [];
  objectGroups:any;
selectedObjectGroup: string;

  extractionTypeData: any
  backgroundColorButton = '';
  validation_messages:any
  FormValid
  addsetsMigrstionData={
    setNumber:0,
    extractionType:''
  };
  extractionType:String
  selectedObjectGroups: any;

  formvalidations() {
    this.FormValid = new UntypedFormGroup({

      'setNumber': new UntypedFormControl('', [Validators.required,Validators.min(1),Validators.pattern('^(\\s*?\\d+((\\-)(\\d)+)?)(\\s*,\\s*?\\d+(\\-(\\d)+)?)*$')]),
      'extractionType': new UntypedFormControl('', [Validators.required]),
      'selectedObjectGroup': new UntypedFormControl('', [Validators.required])
    });
  }
  constructor(public dialogref: MatDialogRef<AddSetsForMigrationPopupComponent>,private validation: validationmethod,private localStorageSettings: LocalStorageSettingsService,private errorMssg:ErrorMessages, private spinner: NgxUiLoaderService, private snackBar: MatSnackBar,private commonService:CommonService,private service:EtlService,@Inject(MAT_DIALOG_DATA) public data:any) {
    this.validation_messages = errorMssg.addSetForMigrationPopup

  }

  ngOnInit(): void {
    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    this.formvalidations();
    this.spinner.start()
    this.service.retrieveSingleRecordService('lookuptype', 'lookuptype', 'Extraction Type').subscribe(response => {
      console.log(response)

      if (response['error'] == true) {

        this.spinner.stop();

        this.snackBar.open(response['statusMessage'], "OK", {duration: 5000});

        return null;

      } else {
        console.log(response[0].lookuptypeid)

        this.service.retrieveSingleRecordService('lookupvalue', 'lookuptypeid',response[0].lookuptypeid).subscribe(response => {
          console.log(response)

          if (response['error'] == true) {

            this.spinner.stop();

            this.snackBar.open(response['statusMessage'], "OK", {duration: 5000});

          } else {
            this.spinner.stop();
            this.extractionTypeData = response;


          }
        });

      }

  console.log('Received active migration id from popup1:', this.data);
  this.getobjectgroupnameById(this.data);
  
    });

  }

  saveData() {
    if (!this.FormValid.valid){

      this.validation.validateAllFormFields(this.FormValid);

      this.validation.getvalidationmessage();

    }
    else {
      const selectedObjectGroup =
  this.FormValid.get('selectedObjectGroup').value;

      console.log(selectedObjectGroup);
      var setNumber = this.addsetsMigrstionData.setNumber
      this.spinner.start()
  //      /**
  //  * @Author DARSHAN NAGARAJ
  //  * @Date 06-02-2026
  //  * @Desc changed the parameter list to pass selected object group 
  //  */
      this.service.insertMigrationTraceRecords(this.extractionType ,setNumber,selectedObjectGroup).subscribe(response => {
        console.log(response)
        if (response['error'] == true) {

          this.spinner.stop();

          this.snackBar.open(response['statusMessage'], "OK", {duration: 5000});

        } else {
          this.spinner.stop();
          this.dialogref.close()
          this.snackBar.open(response['statusMessage'], "OK", {duration: 5000});

        }
      });


    }


  }

  close() {
    this.dialogref.close()
  }

  onMigrationTypeChange(e: any) {
    console.log(e)
   this.extractionType = e.lookupvalue

    if (e.lookupcode === 'VV'){
      this.FormValid.get('setNumber').disable();
      this.FormValid.get('setNumber').setValue(0);

    }
    else {
      this.FormValid.get('setNumber').enable()
    }

  }
  //   /**
  //  * @Author DARSHAN NAGARAJ
  //  * @Date 06-02-2026
  //  * @Desc function to get group name by id
  //  */
  getobjectgroupnameById(data)
  {
    console.log("data----------->"+data+"=====" );
      const dnsid = this.localStorageSettings.getSettings("dnsName");

    //need to call api list of object group id in return responce to featch object groupname for id 
    
    this.service.getselectedObjectGroupsNames(data, dnsid).subscribe(
  result => {
this.objectGroupOptions = result.map(r => r.objectgroupname);
    console.log("result------>",this.objectGroups)
  },
  error => console.error(error)
 );

  }
}
